import { render, staticRenderFns } from "./Banking-Requirements.vue?vue&type=template&id=2d2fc9e8&"
import script from "./Banking-Requirements.vue?vue&type=script&lang=js&"
export * from "./Banking-Requirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports